export default {
  methods: {
    addToCart (quantity) {
      const {
        priceFormatted,
        benefitList,
        finalPrice,
        finalPricePure,
        imageUrl,
        price,
        price30d,
        price30dFormatted,
        name,
        productName,
        id,
      } = this;

      const cartData = {
        priceFormatted,
        benefitList,
        finalPrice,
        finalPricePure,
        imageUrl,
        quantity,
        name,
        productName,
        price,
        price30d,
        price30dFormatted,
        id,
      }

      let subOrder = [];

      try {
        subOrder = JSON.parse(localStorage.getItem('subOrder')) || [];
      }
      catch (err) {

      }

      if (id) {
        subOrder.push(cartData);
      }

      localStorage.setItem('subOrder', JSON.stringify(subOrder));

      this.$emit('addAccessory', cartData)
    },

    // This function returns quantity of upsells user can add to his order. No greater than main products purchased
    getAllowedUpsellQty() {
      // new rule - by default always 5
      return 5; 

      // how many main items user purchased
      let purchasedQty = js_data.order_customer.products[0].quantity || 1;
      const mainProductId = localStorage.getItem('product_id');
      
      if (localStorage.getItem('subOrder')) {
        purchasedQty += JSON.parse(localStorage.getItem('subOrder')).filter(item => item.id === mainProductId).length;
      }

      return purchasedQty > 5 ? 5 : purchasedQty;
    },

    // return video or gif or image if none exists
    getProductImageHtml() {
      if (this.videoFile) {
        return `<div class='embed-container'>
          <video width="442" height="335" autoplay muted><source src="${this.videoFile}" type="video/mp4"></video>
          </div>`;
      }
      else if (this.vimeoId) {
        return `<div class='embed-container'>
          <iframe src='https://player.vimeo.com/video/${this.vimeoId}?autoplay=1' frameborder='0' webkitAllowFullScreen mozallowfullscreen allowFullScreen allow=autoplay></iframe>
          </div>`;
      }
      else if (this.gifImageUrl) {
        return `<img src="${this.gifImageUrl}" class="mw-100" alt="" />`;
      }
      else {
        return `<img src="${this.imageUrl}" class="mw-100" alt="" />`;
      }
    }
  },

}
